import { fetchAutoFill } from '@/features/adp/api/autoFills.api'
import {
  createDataFlow,
  type DataFlowBootstrapResponse,
} from '@/features/adp/api/pipelineLists.api'

const PIPELINE_AUTO_FILL_PARAMS = {
  baseName: 'My_ADP_Pipeline',
  tableName: 'data_flow',
} as const

export async function initializePipelineDataFlow(): Promise<DataFlowBootstrapResponse> {
  try {
    const autoFill = await fetchAutoFill(PIPELINE_AUTO_FILL_PARAMS)
    const suggestedName = (autoFill.suggestedName ?? '').trim()
    const dataFlowName = suggestedName || 'Untitled_Pipeline'

    return await createDataFlow({
      data_flow_name: dataFlowName,
      session_id: crypto.randomUUID(),
      description: '',
      purpose: '',
      status: '',
      web_socket_connection_id: '',
      data_flow_type: 'ETL',
      validate_source_name: false,
      source_names: [],
    })
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message || 'Failed to initialize pipeline.')
    }

    throw new Error('Failed to initialize pipeline.')
  }
}
